import MtsTakipAc from "../../../takip_ac/MtsTakipAc";
import {TaskDurum} from "../../../enum/TaskDurum";
import {MtsXmlParser} from "../../../takip_ac/MtsXmlParser";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";

export class MtsTakipOdemeYapTaskHandler extends AbstractTaskHandler {
    async handle(task: ITask): Promise<ITask> {
        console.log("handle MtsTakipOdemeYapTaskHandler TASK HANDLER", task);
        try {
            //BURASI TAKIP AÇMA
            let takip: MtsTakipAc = MtsTakipAc.fromJson(task.data);
            console.log("MTS TAKIP AC OBJECT",takip);
            await takip.takipBaslat();
            task.response = takip;
            // UYAP'ta takip açıldı ama kart ya da hash kaydı güncellenemediyse görev eksik biter;
            // neden açıklamaya yazılır, ekran eksik satırda onu gösterir (DEV-3302).
            task.status = (takip.icraProSenkronHatasi || takip.hashGuncellemeHatasi) ? TaskDurum.BITTI_EKSIK : TaskDurum.BITTI_BASARILI;
            if (task.status == TaskDurum.BITTI_EKSIK)
                task.description = takip.eksikBitisAciklamasi();
            return task
        } catch (e) {
            console.log("e",e);
            throw new Error(e.message);
        }
    }

}